import { Modal, Button } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import ExtractModel from "../../ExtractModel/ExtractModel";
import { useNavigate } from "react-router-dom";

const ModalExtractVisualizacao = ({
  show,
  onClose,
  onSolicitarConfirmacaoEnvio,
  idResposta,
  idSindicato,
  previewData,
  deducaoData,
  dadosSindicato,
  quantidadeAdimplentes,
  receita,
  associado,
}) => {
  const navigate = useNavigate();

  const handleExpand = () => {
    onClose();
    setTimeout(() => {
      navigate(`/extractModal/${idResposta}/${idSindicato}`, {
        replace: true,
        state: {
          quantidadeAdimplentes,
          receita,
          associado,
          previewData,
          deducaoData,
          dadosSindicato,
        },
      });
    }, 100);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="xl"
      contentClassName="modal-extract-custom"
      style={{ border: "1px solid #D9D9D9", borderRadius: "12px" }}
    >
      <Modal.Header>
        <Modal.Title style={{ color: "#005ca9", fontWeight: "bold" }}>
          EXTRATO
        </Modal.Title>
        <Button
          variant="link"
          onClick={onClose}
          style={{
            color: "#005ca9",
            fontSize: 32,
            marginRight: -10,
            marginTop: -10,
          }}
          className="p-0 ms-auto"
          aria-label="Fechar"
        >
          <X />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div
          className="extrato-img-container mb-4"
          style={{
            maxHeight: "60vh",
            overflowY: "auto",
            overflowX: "hidden",
            border: "1px solid #D9D9D9",
            borderRadius: "8px",
            padding: "4px",
          }}
        >
          <ExtractModel
            previewMode={true}
            idResposta={idResposta}
            idSindicato={idSindicato}
            previewData={previewData}
            dadosSindicato={dadosSindicato}
            deducaoData={deducaoData}
            quantidadeAdimplentes={quantidadeAdimplentes}
            receita={receita}
            associado={associado}
          />
        </div>
        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <span
            style={{
              color: "#1A772F",
              fontWeight: 700,
              fontSize: 18,
              cursor: "pointer",
              display: "inline-block",
            }}
            onClick={handleExpand}
          >
            &#x2922; Expandir
          </span>
        </div>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button
          variant="danger"
          onClick={onClose}
          style={{ minWidth: "140px" }}
        >
          CANCELAR
        </Button>
        <Button
          variant="success"
          onClick={onSolicitarConfirmacaoEnvio}
          style={{ minWidth: "140px" }}
        >
          ENVIAR
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalExtractVisualizacao;
